
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Lager 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21.5 21.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.13 21.5a2 2 0 01-.67-.12 2.14 2.14 0 01-1.25-1.11 2.26 2.26 0 010-2l4.53-7.53L.28 3.26A2.21 2.21 0 011.1.31a2.11 2.11 0 012-.06l17.61 9.19a1.47 1.47 0 01.63 2 1.39 1.39 0 01-.63.64L3.1 21.26a2.11 2.11 0 01-.97.24zm-.56-19l4.68 7.86a.74.74 0 010 .76L1.57 19a.71.71 0 000 .62.63.63 0 00.38.34.59.59 0 00.47 0l17.57-9.22L2.4 1.56a.58.58 0 00-.57 0 .7.7 0 00-.26.94z"}}),_c('path',{attrs:{"d":"M20.74 11.49H5.6a.75.75 0 110-1.5h15.14a.75.75 0 010 1.5z"}})])
          )
        }
      }
    